import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import {SortType, SortEvent} from "./models";
import {SortableService} from "./sortable.service";
import {Subject, takeUntil} from "rxjs";

@Directive({
  /* eslint-disable @angular-eslint/directive-selector */
  selector: "[sortable]",
})
export class SortableHeaderDirective implements OnInit, OnDestroy {
  /* eslint-disable @angular-eslint/no-input-rename */
  @Input() sortable: string;
  @Output() updateSorting = new EventEmitter<SortEvent>();
  private _sortType: SortType;
  private _destroy: Subject<void> = new Subject<void>();
  private _activeSortable: string;

  constructor(private host: ElementRef, private renderer: Renderer2, private sortableService: SortableService) {}

  @HostListener("click")
  private hostClick(): void {
    this.rotate();
  }

  ngOnInit(): void {
    this._sortType = SortType.default;

    this.sortableService
      .activeSortable$()
      .pipe(takeUntil(this._destroy))
      .subscribe((sortable: string) => {
        this._activeSortable = sortable;
        if (this._activeSortable !== this.sortable) {
          this.renderer.removeClass(this.host.nativeElement, SortType.asc);
          this.renderer.removeClass(this.host.nativeElement, SortType.desc);
          this._sortType = SortType.default;
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }

  private changeDirection({column, sortType}: SortEvent): void {
    if (column === this._activeSortable) {
      switch (sortType) {
        case SortType.asc:
          this.renderer.removeClass(this.host.nativeElement, SortType.desc);
          this.renderer.addClass(this.host.nativeElement, SortType.asc);
          break;

        case SortType.desc:
          this.renderer.removeClass(this.host.nativeElement, SortType.asc);
          this.renderer.addClass(this.host.nativeElement, SortType.desc);
          break;

        case SortType.default:
          this.renderer.removeClass(this.host.nativeElement, SortType.asc);
          this.renderer.removeClass(this.host.nativeElement, SortType.desc);
          break;
      }
    }
  }

  private rotate() {
    this._sortType = rotate[this._sortType];
    this.updateSorting.emit({column: this.sortable, sortType: this._sortType});
    this.changeDirection({column: this.sortable, sortType: this._sortType});
  }
}

const rotate: {[key: string]: SortType} = {
  asc: SortType.desc,
  desc: SortType.default,
  "": SortType.asc,
};

export const compare = (v1: string | null, v2: string | null, direction: SortType): number => {
  if (v1 === null) {
    return 1;
  }

  if (v2 === null) {
    return -1;
  }

  if (v1 === v2) {
    return 0;
  }

  if (v1 < v2) {
    return direction === SortType.asc ? -1 : 1;
  }

  if (v1 > v2) {
    return direction === SortType.asc ? 1 : -1;
  }

  return 0;
};
